import Pages from '../../../config/Pages';
import { Route } from '../../../core/utils/RouteMixins';
import Form from './MetasResultados';

const metasResultadosRoutes = [Route(null, Pages.sei.metasResultados.url.list, Form)];

export default metasResultadosRoutes;
